import { render, staticRenderFns } from "./DinnerDaily.vue?vue&type=template&id=670f127c&scoped=true&"
import script from "./DinnerDaily.vue?vue&type=script&lang=js&"
export * from "./DinnerDaily.vue?vue&type=script&lang=js&"
import style0 from "./DinnerDaily.vue?vue&type=style&index=0&id=670f127c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f127c",
  null
  
)

export default component.exports